import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Image } from '@chakra-ui/react';
import Cookies from 'universal-cookie';

import { DashboardIcon, OutIcon } from 'Asset/icon';
import forbiddenImage from 'Asset/image/siglive-forbidden-state.svg';
import { Condition } from 'Component/others';
import { forbiddenTitleText, logoutText, dashboardText, relogText, relogLinkText } from 'Const/forbidden/text';
import useIsMobile from 'Hook/useIsMobile';
import { TextBold, TextRegular } from 'UiKit/typography';
import ButtonSolid from 'UiKit/button/buttonSolid';

import useLogout from 'Domain/logout/usePostLogout';
import getDescriptionText from 'View/forbidden/helper/getDescriptionText';

import styles from './styles.module.css';

const ForbiddenPage = () => {
  const cookies = new Cookies();
  const userIdentity = cookies.get('userIdentity');
  const isBackoffice = userIdentity?.isBackoffice;

  const { mutate: onLogout } = useLogout();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const isExpiredToken = searchParams.get('reason') === 'expired';

  const isWrongView = (isBackoffice && isMobile) || (!isBackoffice && !isMobile);

  const descriptionText = getDescriptionText(isWrongView, isMobile);

  return (
    <Box className={styles['forbidden-page__container']}>
      <Image src={forbiddenImage} className={styles['ilustration__image']} />
      <TextBold className={styles['forbidden-title__text']}>{forbiddenTitleText}</TextBold>
      <TextRegular className={styles['forbidden-description__text']}>{descriptionText}</TextRegular>
      <Box className={styles['button__container']}>
        <Condition
          statement={!isWrongView && !isExpiredToken}
          fallback={
            <ButtonSolid onClick={() => onLogout({})}>
              <OutIcon color="var(--color-semantic-white)" />
              <TextRegular className={styles['main-page__text']} marginLeft="8px">
                {logoutText}
              </TextRegular>
            </ButtonSolid>
          }
        >
          <ButtonSolid onClick={() => navigate('/')}>
            <DashboardIcon color="var(--color-semantic-white)" />
            <TextRegular className={styles['main-page__text']} marginLeft="8px">
              {dashboardText}
            </TextRegular>
          </ButtonSolid>
        </Condition>
      </Box>
      <Condition statement={!isWrongView && !isExpiredToken}>
        <Box className={styles['relog__container']}>
          <TextRegular className={styles['relog__text']} fontSize={isMobile ? 'var(--font-body3)' : 'var(--font-body1)'}>
            {relogText}{' '}
            <span className={styles['relog-link__text']} onClick={() => onLogout({})}>
              {relogLinkText}
            </span>
          </TextRegular>
        </Box>
      </Condition>
    </Box>
  );
};

export default ForbiddenPage;
